<template>
    <div class="pb-0 card-header">
        <div class="d-lg-flex gap-2">
            <div>
                <h5 class="mb-0">{{ title }}</h5>
                <p class="mb-0 text-sm">{{ description }}</p>
            </div>
            <div class="my-auto mt-4 ms-auto mt-lg-0">
                <div class="my-auto ms-auto mt-2 gap-2 d-flex flex-wrap">
                    <Button id="exportLogs" color="primary" variant="outline" :title="$t('key_log_export_excel')" class="mb-0" :disabled="isExporting" @click="exportLogs">
                        <i class="fa-solid fa-file-excel me-1" aria-hidden="true"></i>{{ $t('key_log_export_excel') }}
                    </Button>
                    <ImportLogTypeFilter id="importLogTypeFilter" :filter-log-type-selected="listFilters?.logType" @log-type-filter-change="logTypeFilterChange"/>
                    <ClearAllFiltersButton id="clearAllFiltersButton" :enable-clear-all-filters="checkActiveFilters()" @clear-all-filters="clearAllFilters"/>
                    <ReloadButton id="reload" :enable-reload="enableReload" @reload-page="reloadPage"/>
                </div>
            </div>
            <div class="mt-4 mt-lg-0">
                <div class="my-auto ms-auto mt-2">
                    <Searchbox id="searchbox" :enable-search="enableSearch" :filter-search="listFilters?.search" @search-change="searchChange"/>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import Button from "./../../../../generic_components/Button.vue";
    import ClearAllFiltersButton from "./../../../../generic_components/ClearAllFiltersButton.vue";
    import ImportLogTypeFilter from "./../filters/ImportLogTypeFilter.vue";
    import ReloadButton from "./../../../../generic_components/ReloadButton.vue";
    import Searchbox from "./../../../../generic_components/Searchbox.vue";

    export default {
        name: "ImportLogListTableHeader",
        components: {
            Button,
            ClearAllFiltersButton,
            ImportLogTypeFilter,
            ReloadButton,
            Searchbox
        },
        props: {
            title: {
                type: String,
                default: ""
            },
            description: {
                type: String,
                default: ""
            },
            enableReload: {
                type: Boolean,
                default: true
            },
            enableSearch: {
                type: Boolean,
                default: true
            },
            isExporting: {
                type: Boolean,
                default: false
            },
            listFilters: {
                type: Object,
                default: () => ({})
            }
        },
        emits: ['clear-all-filters', 'search-change', 'reload-page', 'log-type-filter-change', 'export-logs'],
        methods: {
            checkActiveFilters() {
                return this.listFilters?.logType !== '' || this.listFilters?.search !== '';
            },
            clearAllFilters() {
                this.$emit("clear-all-filters");
            },
            logTypeFilterChange(logType) {
                this.$emit("log-type-filter-change", logType);
            },
            reloadPage() {
                this.$emit("reload-page");
            },
            searchChange(searchValue) {
                this.$emit("search-change", searchValue);
            },
            exportLogs() {
                this.$emit("export-logs");
            }
        }
    }

</script>
